import type { EnrichmentMatchStatus } from '@hp/domain';
import type { EnrichmentStats } from './queries';

/** Match-status tabs; the label is `t('tabs.<value>')` in the `enrichment` catalog. */
export const TABS: Array<{ value: EnrichmentMatchStatus; count: (s: EnrichmentStats) => number }> = [
  { value: 'pending', count: (s) => s.pending },
  { value: 'auto_accepted', count: (s) => s.autoAccepted },
  { value: 'accepted', count: (s) => s.accepted },
  { value: 'rejected', count: (s) => s.rejected },
  { value: 'no_match', count: (s) => s.noMatch },
];
